import { getProductId } from '../../order-builder/modules/specification/helpers/product.helper';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable } from 'rxjs';
import { map, switchMap, take, filter } from 'rxjs/operators';
import { ProductService, UnitsResponse } from '@cemex-core/cmx-api';
import {
  OneClickLoadUnitsCompleteAction,
  OneClickUnitsActionTypes,
  OneClickLoadUnitsBuilderAction,
} from '../actions/one-click-units.actions';
import { Store } from '@ngrx/store';
import { State } from '../reducers';
import { getOneClickState, OneClickState } from '../reducers';

@Injectable()
export class OneCLickAlternativeUnitsBuilderEffects {
  loadOneClicklternativeUnits: Observable<OneClickLoadUnitsCompleteAction> = createEffect(() =>
    this.actions$.pipe(
      ofType(OneClickUnitsActionTypes.LOAD_UNITS_BUILDER),
      switchMap((action: OneClickLoadUnitsBuilderAction) =>
        this.store.select(getOneClickState).pipe(
          filter((state) => !!state.productsState.selected),
          take(1),
          map((state) => ({ state, index: action.index })),
        ),
      ),
      map(({ state, index }) => this.makeUnitsRequestFromState(state, index)),
      switchMap((request) => this.productService.getUnits(request.productId)),
      map((response: UnitsResponse) => new OneClickLoadUnitsCompleteAction(response.productUnitConversions)),
    ),
  );

  private makeUnitsRequestFromState(state: OneClickState, index: number) {
    return {
      productId: getProductId(state.productsState.selected[index]),
    };
  }

  constructor(
    private actions$: Actions,
    private store: Store<State>,
    private productService: ProductService,
  ) {}
}
